<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :isDashboardView='true'
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div style="display:flex; flex-direction:row; align-content:center; justify-content:space-between;">
                <div>
                    <h2>
                        {{ dashUserDesc }} DASHBOARD: 
                        <span style="font-weight:200;text-transform:none;">{{ fullName }}</span><br>
                        <em style="font-weight:normal; font-size:1.0rem;">{{ dashDesc }}</em>
                    </h2>
                </div>
                <div style="align-self:flex-end; text-align:center;">
                    <span style="color:#ccc;font-size:1rem;">------ DASHBOARD VIEW ------</span>
                    <p>
                        <img v-on:click="updateDashboard('PriceDeviation')" id="dashICON" :src="dashIconDeviation" />
                        <img v-on:click="updateDashboard('PumaPromo')" id="dashICON" :src="dashIconPromo" />
                        <img v-on:click="updateDashboard('LevelDeviation')" id="dashICON" :src="dashIconPriceLevel" />
                    </p>
                    <span style="font-weight:bold;font-size:20px;">{{ dashboardTitle }} DASHBOARD</span>
                </div>
            </div>
            <price-deviation-dashboard v-if="dashboard == 'PriceDeviation'"
                @delete-entry="deleteEntry"
                @bulk-action="performBulkAction"
            ></price-deviation-dashboard>
            <price-puma-promo-dashboard v-else-if="dashboard == 'PumaPromo'"
                @delete-entry="deleteEntry"
                @bulk-action="performBulkAction"
            ></price-puma-promo-dashboard>
            <price-level-dashboard v-else-if="dashboard == 'LevelDeviation'"
                @delete-entry="deleteEntry"
                @bulk-action="performBulkAction"
            ></price-level-dashboard>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            dashboard: this.$route.params.dashboard || 'PriceDeviation',
            dashboardTitle: 'PRICE DEVIATION',
            dashDesc: '',
            dashIconDeviation: '/images/icon-circle-dollar-red.png',
            dashIconDeviationGray: '/images/icon-circle-dollar-gray.png',
            dashIconDeviationRed: '/images/icon-circle-dollar-red.png',
            dashIconPriceLevel: '/images/icon-circle-level-gray.png',
            dashIconPriceLevelGray: '/images/icon-circle-level-gray.png',
            dashIconPriceLevelRed: '/images/icon-circle-level-red.png',
            dashIconPromo: '/images/icon-circle-star-gray.png',
            dashIconPromoGray: '/images/icon-circle-star-gray.png',
            dashIconPromoRed: '/images/icon-circle-star-red.png',
            dashUserDesc: '',
            fullName: '',
            userRole: '',
        }
    },
    methods: {
        updateDashboard(dashboardName) {
            this.dashboard = dashboardName;
        },
        deleteEntry(ppId) {
            axios.post(`/api/deleteSubmission`, {ppId: ppId}).then(response => {
                this.$emit(`trigger${this.dashboard}DashboardRefresh`);
            });
        },
        performBulkAction({action, signOffStatus, submissionIds, userId}) {
            let data = {
                action: action,
                signOffStatus: signOffStatus,
                submissionIds: submissionIds,
                userId: userId
            }
            
            axios.post(`/api/performBulkAction`, data).then(response=> {
                this.$emit(`trigger${this.dashboard}DashboardRefresh`);
            });
        },
        handleDashboardChange() {
            if(this.dashboard == 'PriceDeviation') {
                this.dashboardTitle = 'PRICE DEVIATION';
                this.dashIconDeviation = this.dashIconDeviationRed;
                this.dashIconPriceLevel = this.dashIconPriceLevelGray;
                this.dashIconPromo = this.dashIconPromoGray;
            } else if (this.dashboard == 'Promo') {
                this.dashboardTitle = 'PROMOTIONS';
                this.dashIconPromo = this.dashIconPromoRed;
                this.dashIconDeviation = this.dashIconDeviationGray;
                this.dashIconPriceLevel = this.dashIconPriceLevelGray;
            } else if (this.dashboard == 'LevelDeviation') {
                this.dashboardTitle = 'PRICE LEVEL';
                this.dashIconPriceLevel = this.dashIconPriceLevelRed;
                this.dashIconDeviation = this.dashIconDeviationGray;
                this.dashIconPromo = this.dashIconPromoGray;
            } else if (this.dashboard == 'PumaPromo') {
                this.dashboardTitle = 'PUMA PROMO';
                this.dashIconPriceLevel = this.dashIconPriceLevelGray;
                this.dashIconDeviation = this.dashIconDeviationGray;
                this.dashIconPromo = this.dashIconPromoRed;
            }
        }
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            priceDeviationAdmins: state => state.priceDeviationAdmins
        })
    },
    watch: {
        dashboard () {
            this.$route.params.status = 'n';
            this.handleDashboardChange();
        },
        user () {
            this.fullName = this.user.full_name;

            if(this.priceDeviationAdmins.includes(this.user.id)) {
                this.dashUserDesc = "ADMIN";
                this.dashDesc = "Showing all submissions, from all teams. You can approve any submission regardless of workflow.";
            } else if (this.user.user_group_id == 10) {
                this.dashUserDesc = "SELLER SUPPORT";
                this.dashDesc = "Showing all submissions and the entire workflow process.";
            } else if (this.user.user_group_id == 9) {
                this.dashUserDesc = "SELLER";
                this.dashDesc = "Showing your submissions and all submissions you are a part of.";
            }
        }
    },
    created() {
        this.handleDashboardChange();
    }
}
</script>

<style scoped>
    #dashICON {
        width: 50px;
        height: auto;
        margin-right: 0.3rem;
    }
</style>